import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';
import { GlobalService } from 'app/services/global.service';
import { HubspotUtil } from 'app/utils/hubspot/hubspot.util';

@Component({
	selector: 'app-signup',
	templateUrl: './signup.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignupComponent implements OnInit {
	@Input() activateBtn: any;
	@Input() activateCheck: any;
	currentPage: any;
	chat: any;
	mobile: any;

	constructor(public global: GlobalService) {
		//no content
	}

	ngOnInit(): void {
		if (this.global.isMobileDevice()) {
			HubspotUtil.widget.hide();
		}
	}

	ngOnDestroy(): void {
		HubspotUtil.widget.show();
	}

	public changePage(newPage) {
		this.currentPage = newPage;
	}

	public activateContinue(activate) {
		this.activateBtn = activate;
	}

	public activateCheckbox(activate) {
		this.activateCheck = activate;
	}
}
